export default __webpack_public_path__ + "static/media/2l001.3d3c9193.png";